export default __webpack_public_path__ + "static/media/image47.ae20f358.jpg";